const customRender = (value, row, index, col) => {
  const obj = {
    children: value,
    attrs: {}
  }
  if (row.children) {
    obj.attrs.rowSpan = 1
    obj.attrs.colSpan = 1
  } else if (index === 0 && col.dataIndex === 'formulaName') {
    obj.attrs.rowSpan = row.nutritionNum
    obj.attrs.colSpan = 3
  } else {
    obj.attrs.colSpan = 0
  }
  return obj
}

export const columns = [
  {
    title: '配方',
    dataIndex: 'formulaName',
    customRender,
    width: 160,
    fixed: 'left'
  },
  {
    title: '代号',
    dataIndex: 'formulaCode',
    width: 120,
    customRender,
    fixed: 'left'
  },
  {
    title: '公司',
    dataIndex: 'factoryName',
    // customRender,
    fixed: 'left',
    scopedSlots: { customRender: 'factoryName' },
    width: 220
  },
  {
    title: ' ',
    dataIndex: 'compensation',
    customRender(value) {
      const obj = {
        children: value,
        attrs: {}
      }
      obj.attrs.colSpan = 0
      return obj
    },
    fixed: 'left',
    width: 0
  },
  {
    title: '营养指标',
    dataIndex: 'nutritionName',
    width: 110
  },
  {
    title: '数值',
    dataIndex: 'content',
    checkable: true,
    checked: true,
    width: 110
  },
  {
    title: '单位',
    dataIndex: 'unit',
    width: 110,
    checked: true,
    checkable: true
  },
  {
    title: '最小值',
    dataIndex: 'minValue',
    checkable: true,
    checked: true,
    width: 110
  },
  {
    title: '最大值',
    dataIndex: 'maxValue',
    checkable: true,
    width: 110
  },
  // {
  //   title: '价格',
  //   dataIndex: 'price',
  //   scopedSlots: { customRender: 'line' },
  //   checkable: true,
  //   width: 110
  // },
  {
    title: '适用下限',
    dataIndex: 'minApply',
    checkable: true,
    width: 110
  },
  {
    title: '适用上限',
    dataIndex: 'maxApply',
    checkable: true,
    width: 110
  },
  {
    title: '成本/单位',
    dataIndex: 'cost',
    checkable: true,
    width: 110
  },
  {
    title: '极下限',
    dataIndex: 'minLimitValue',
    checkable: true,
    width: 110
  },
  {
    title: '极上限',
    dataIndex: 'maxLimitValue',
    checkable: true,
    width: 110
  },
  {
    title: '',
    dataIndex: 'maxApplyp'
  }
]
export const columns2 = [
  {
    title: '配方',
    dataIndex: 'formulaName',
    // customRender,
    width: 160,
    fixed: 'left'
  },
  {
    title: '代号',
    dataIndex: 'formulaCode',
    width: 120,
    // customRender,
    fixed: 'left'
  },
  {
    title: '公司',
    dataIndex: 'factoryName',
    // customRender,
    fixed: 'left',
    scopedSlots: { customRender: 'factoryName' },
    width: 220
  },
  {
    title: ' ',
    dataIndex: 'compensation',
    // customRender(value) {
    //   const obj = {
    //     children: value,
    //     attrs: {}
    //   }
    //   obj.attrs.colSpan = 0
    //   return obj
    // },
    // fixed: 'left',
    // width: 0
  },
  {
    title: '营养指标',
    dataIndex: 'nutritionName',
    width: 110
  },
  {
    title: '数值',
    dataIndex: 'content',
    checkable: true,
    checked: true,
    width: 110
  },
  {
    title: '单位',
    dataIndex: 'unit',
    width: 110,
    checked: true,
    checkable: true
  },
  {
    title: '最小值',
    dataIndex: 'minValue',
    checkable: true,
    checked: true,
    width: 110
  },
  {
    title: '最大值',
    dataIndex: 'maxValue',
    checkable: true,
    width: 110
  },
  // {
  //   title: '价格',
  //   dataIndex: 'price',
  //   scopedSlots: { customRender: 'line' },
  //   checkable: true,
  //   width: 110
  // },
  {
    title: '适用下限',
    dataIndex: 'minApply',
    checkable: true,
    width: 110
  },
  {
    title: '适用上限',
    dataIndex: 'maxApply',
    checkable: true,
    width: 110
  },
  {
    title: '成本/单位',
    dataIndex: 'cost',
    checkable: true,
    width: 110
  },
  {
    title: '极下限',
    dataIndex: 'minLimitValue',
    checkable: true,
    width: 110
  },
  {
    title: '极上限',
    dataIndex: 'maxLimitValue',
    checkable: true,
    width: 110
  },
  {
    title: '',
    dataIndex: 'maxApplyp'
  }
]
export const pagination = {
  total: 0,
  pageSize: 20,
  current: 1,
  showSizeChanger: true,
  showTotal: total => `共${total}条记录`
}
